module.exports = __webpack_public_path__ + "media/components/assets/img/bg/flyo-booking-airport-4035150063225d8cf9adc3226d1d846f.svg";